import { QueryClient, QueryClientProvider } from "react-query";
import { PricePage } from "./pages/priceRage";
import { BrowserRouter } from "react-router-dom";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      notifyOnChangeProps: "tracked",
      staleTime: 60 * 1000 * 10,
      refetchOnMount: false,
      retry: false,
    },
  },
});

function App() {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <PricePage />
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
